import {DoccliService} from '../../../providers/DoccliService.js';

const doccliService = new DoccliService();

export default {
  beforeMount: async function () {
    


  },
  mounted:  async function () {
    await this.createDossier();
    this.scanDocument();
  },
  methods: {
    annuler: function(){
      this.$root.progress = false;
      this.$router.push({path: '/choixcategorieoffre'});
    },
    createDossier: async function(){
      this.$root.progress = true;
      const idSouscription='';
      const typeScan ='';
      //si doccli_id exist en session 
      //if()
      await doccliService.createDossier(idSouscription, typeScan).then(res => { 
        this.$root.progress = false;
        if(res){
          if (res.err !='error') {
            const doccli_id = res.params.doccli_id;
            //sessionStorage.setItem("doccli_id",res.data.doccli_id);
           
            const sessionSouscription = this.$globalService.setSessionSouscription('doccli_id',doccli_id);
            
            if(sessionSouscription == null || !sessionSouscription.doccli_id){
              this.$dialog.error({
                text: "Une erreur s'est produite",
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            }
          }else{
            this.$dialog.error({
              text: "Une erreur s'est produite",
              title: 'Erreur',
              persistent: false,
              actions: {
                false: 'Fermer'
              }
            })
          
          }
        }

      }).catch(error=>{
    
        this.loading = false;
        this.$dialog.notify.error(this.$root.errorMessage, {
                  position: 'bottom-right',
                  timeout: 5000
                })
      return error;
    })
    },
    scanDocument: function(){
      this.$root.progress = true;
      if(!this.$globalService.isDevicePC(this.$device, this.$root.ariadNextShowMode)){
        //getTokenScan
        doccliService.getTokenAppScan().then(res => { 
          if(res){
            if (res && res.err !='error') {
              const tokenScan = res.params.tokenAppScan;
              
              window.location.href = tokenScan;
              
            }else{
              this.$root.progress = false;
              this.$dialog.error({
                text: "Erreur lors du lancement de l'application de ARIAD NEXT ",
                title: 'Erreur',
                persistent: false
              })
            
            }
          }
        }).catch(error=>{
    
          this.loading = false;
          this.$dialog.notify.error(this.$root.errorMessage, {
                    position: 'bottom-right',
                    timeout: 5000
                  })
        return error;
      })

      }else{
        this.$root.progress = false;
          // affichage du qrcode
          // lancement du component QrcodeScan
          //this.$router.push({ name: 'QrcodeScan'});
          this.$router.push({path: '/souscription/qrcode/qrcodescan'});
      }

      
    }
  }
}